export default {
    mounted(el, binding) {

        // Création du spinner
        const spinner = document.createElement('div');
        spinner.className = 'spinner';
        spinner.style.border = '4px solid rgba(0, 0, 0, 0.1)';
        spinner.style.borderTop = '4px solid #333';
        spinner.style.borderRadius = '50%';
        spinner.style.width = '40px';
        spinner.style.height = '40px';
        spinner.style.position = 'absolute';
        spinner.style.top = '50%';
        spinner.style.left = '50%';
        spinner.style.transform = 'translate(-50%, -50%)';
        spinner.style.animation = 'spin 1s linear infinite';
        el.appendChild(spinner); // Ajoute le spinner comme enfant de l'élément ciblé par la directive

        // Appliquer un fond blanc par défaut
        el.style.backgroundColor = '#fff';
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = 'center';

        // Délai avant de charger l'image réelle
        const delay = 500;

        const loadBackgroundImage = () => {
            setTimeout(() => {
                el.style.backgroundImage = `url("${binding.value}")`;
                if (el.contains(spinner)) {
                    el.removeChild(spinner); // Retire le spinner de l'élément une fois l'image de fond chargée
                }
            }, delay);
        };

        if ('IntersectionObserver' in window) {
        // Vérifie si l'API IntersectionObserver est disponible dans le navigateur
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Si l'élément est visible dans la fenêtre de visualisation
                    loadBackgroundImage(); // Charge l'image de fond avec un délai
                    observer.unobserve(el); // Arrête d'observer l'élément pour ne pas charger l'image plusieurs fois
                }
                });
            });
            observer.observe(el); // Commence à observer l'élément
        } else {
            loadBackgroundImage(); // Si IntersectionObserver n'est pas disponible, charge l'image de fond immédiatement
        }
    }
  };

  